// Wire ↔ store name map for all FLAT preference fields. Drives the reducer
// (fetch/patch/revert) and the saga's revert snapshot, so a new field is
// added in exactly one place. The nested `diagram` object is handled
// separately (deep-merged like the backend does).
export const PREF_FIELDS = [
    { wire: 'theme', store: 'theme' },
    { wire: 'sidebar_collapsed', store: 'sidebarCollapsed' },
    { wire: 'language', store: 'language' },
    { wire: 'timezone', store: 'timezone' },
    { wire: 'notifications_diagram_shared', store: 'notificationsDiagramShared' },
    { wire: 'notifications_mentions', store: 'notificationsMentions' },
    { wire: 'notifications_product_updates', store: 'notificationsProductUpdates' },
];
